import { render, staticRenderFns } from "./InputSelectRegion.vue?vue&type=template&id=704d25de&scoped=true&"
import script from "./InputSelectRegion.vue?vue&type=script&lang=ts&"
export * from "./InputSelectRegion.vue?vue&type=script&lang=ts&"
import style0 from "./InputSelectRegion.vue?vue&type=style&index=0&id=704d25de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d25de",
  null
  
)

export default component.exports